import { PanelCategory, PanelConfig } from '@helios/panel-base'
import { OutputManagerPanelComponent } from './lib/output-manager-panel.component'
import { OutputManagerKey } from './panel-key'

export * from './lib/output-manager.module'
export * from './panel-key'

export const OutputManagerPanelConfig: PanelConfig = {
  key: OutputManagerKey,
  title: 'Output Manager',
  description:
    'Generate and Download Reconciliation Output reports for the Enfusion Dashboard.',
  category: PanelCategory.SUPPLEMENTARY,
  panelComponent: OutputManagerPanelComponent,
  accessPermission: 'accessOutputManagerPanel',
}
